import { NgModule } from '@angular/core';
import { AbsoluteDragDirective } from './absolute-drag/absolute-drag';
@NgModule({
	declarations: [AbsoluteDragDirective],
	imports: [],
	exports: [AbsoluteDragDirective]
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts